const hasValue = (value) => {
  return value !== null && value.trim() !== ''
}

export const validation = {
  hasValue,
}
